/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type EstimateIndexPricesQueryVariables = Types.Exact<{
	input: Types.EstimateIndexPricesInput;
}>;

export type EstimateIndexPricesQuery = {
	__typename?: "Query";
	estimateIndexPrices: {
		__typename?: "EstimateIndexPricesResponse";
		fiat: { __typename?: "EstimateIndexPricesFiat"; min: string; max: string };
	};
};

export const EstimateIndexPricesDocument = gql`
	query estimateIndexPrices($input: EstimateIndexPricesInput!) {
		estimateIndexPrices(input: $input) {
			fiat {
				min
				max
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class EstimateIndexPricesGQLService extends Apollo.Query<
	EstimateIndexPricesQuery,
	EstimateIndexPricesQueryVariables
> {
	document = EstimateIndexPricesDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
